const doc = [({"en":({"adminConstantHotelPushMessageGroupStatus":({"created":"CREATED", "pushed":"PUSHED", "pushing":"PUSHING"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;